import React, { Fragment, useMemo } from 'react';
import { Header } from 'semantic-ui-react';
import XTab from '../../common/tabs/XTab';
import AchContainer from './AchContainer';
import Jurisdictions from './Jurisdictions';
import Exchanges from './Exchanges/Exchanges';

const getPanes = () => {
  const panes = [
    { url: 'ach', menuItem: 'ACH Banking', render: () => <AchContainer /> },
    {
      url: 'jurisdictions',
      menuItem: 'Jurisdictions',
      render: () => <Jurisdictions />,
    },
    {
      url: 'exchanges',
      menuItem: 'Exchanges',
      render: () => <Exchanges />,
    },
  ];

  return panes;
};

const ConfigurationContainer = () => {
  const panes = useMemo(() => getPanes(), []);

  return (
    <Fragment>
      <Header as="h1" dividing>
        System Configuration
      </Header>
      <XTab panes={panes} />
    </Fragment>
  );
};

export default ConfigurationContainer;
